import { Box, Grid } from "@material-ui/core";
import React from "react";
import FailIcon from "../../assets/summary/FailIcon.svg";
import IconTitle from "../shared/components/IconTitle";
import Text from "../shared/components/Text";

export default function NotAllowedView() {
  return (
    <>
      <Box style={{ height: "25vh" }} />
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className="p-2"
      >
        <Grid item>
          <IconTitle
            icon={
              <img
                alt="Not allowed icon"
                src={FailIcon}
                height="60px"
                style={{ paddingBottom: 12 }}
              />
            }
            title={<Text tId="SORRY" />}
            subtitle={<Text tId="PROCESS_NOT_ALLOWED_FOR_THIS_LOAN" />}
          />
        </Grid>
      </Grid>
    </>
  );
}
